import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function CustomModal(props) {
      const navigate = useNavigate();
  const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >

      <Modal.Body>
  
<div className='d-flex justify-content-center flex-column align-items-center'>
    <Button className='w-75  bg_main border-0 py-3'onClick={()=>navigate("/choose-stage")}>
{currentLocal.home.studentregistering}
  </Button>
  <br/>
    <Button className='w-75  border-0 py-3'onClick={()=>navigate("/login")}>
    {currentLocal.home.studyingatschool}
  </Button>
</div>
      </Modal.Body>
  
    </Modal>

)
}

export default CustomModal